import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from '@nuxtjs/composition-api'
import { Checkbox } from '@shared/ui'
import { usePrivacyPolicyModel } from './../model'


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyPolicyCheck',
  setup(__props) {

const status = ref('policy')

const privacyPolicyModel = usePrivacyPolicyModel()

const onChange = () => {
  if (privacyPolicyModel.status) {
    status.value = ''
  } else {
    status.value = 'policy'
  }
  privacyPolicyModel.status = !privacyPolicyModel.status
}

onMounted(() => {
  if (privacyPolicyModel.status) {
    status.value = 'policy'
  } else {
    status.value = ''
  }
})

return { __sfc: true,status, privacyPolicyModel, onChange, Checkbox }
}

})